// extracted by mini-css-extract-plugin
export var accordionWrapper = "style-module--accordionWrapper--05587";
export var accordions = "style-module--accordions--9fcc3";
export var content = "style-module--content--577ba";
export var label = "style-module--label--1e6bb";
export var red = "style-module--red--7b9cf";
export var title = "style-module--title--f3de5";